import React, { FC, HTMLAttributes, RefCallback, RefObject } from 'react';
// @ts-ignore
import BrowserSymbol from 'svg-baker-runtime/browser-symbol';
// @ts-ignore
import { assign } from 'es6-object-assign';
import { addSpriteSymbol, useIsomorphicLayoutEffect } from '../sprite';
import { SvgIcon } from '../SvgIcon';

const viewBox = '0 0 56 56';
const id = 'palette_outline_56';
const content = '<symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" id="palette_outline_56"><g fill="currentColor"><path d="M18 27a3 3 0 11-6 0 3 3 0 016 0zM44 27a3 3 0 11-6 0 3 3 0 016 0zM25 17a3 3 0 11-6 0 3 3 0 016 0zM37 17a3 3 0 11-6 0 3 3 0 016 0z" /><path clip-rule="evenodd" d="M4 28C4 14.766 14.766 4 28 4c12.76 0 24 9.176 24 21.451C52 33.12 45.78 39 38.195 39h-4.511C32.298 39 31 40.332 31 42c0 .74.214 1.375.612 1.822l.023.026.023.027.03.033C31.993 44.264 33 45.431 33 47c0 2.828-2.172 5-5 5C14.766 52 4 41.234 4 28zM28 7C16.423 7 7 16.423 7 28s9.423 21 21 21c1.172 0 2-.828 2-2 0-.159-.055-.352-.185-.582s-.29-.421-.435-.59l-.003-.005-.004-.005C28.375 44.698 28 43.292 28 42c0-3.036 2.366-6 5.684-6h4.511C44.206 36 49 31.38 49 25.451 49 15.207 39.504 7 28 7z" fill-rule="evenodd" /></g></symbol>';

let isMounted = false;
function mountIcon() {
  if (!isMounted) {
    addSpriteSymbol(new BrowserSymbol({
      id: id,
      viewBox: viewBox,
      content: content,
    }));

    isMounted = true;
  }
}

export interface Icon56PaletteOutlineProps extends HTMLAttributes<HTMLDivElement> {
  fill?: string;
  width?: number;
  height?: number;
  getRootRef?: RefCallback<HTMLDivElement> | RefObject<HTMLDivElement>;
}

const Icon56PaletteOutline: FC<Icon56PaletteOutlineProps> = (props) => {
  useIsomorphicLayoutEffect(() => {
    mountIcon();
  }, []);

  return React.createElement(SvgIcon, assign({}, props, {
    viewBox: viewBox,
    id: id,
    width: !isNaN(props.width) ? +props.width : 56,
    height: !isNaN(props.height) ? +props.height : 56,
  }));
};

(Icon56PaletteOutline as any).mountIcon = mountIcon;

export default Icon56PaletteOutline;
